module.exports = "/_next/static/images/61eb1520b245d7e6230cb50c41f3ca29-slide4mobile.jpg.webp";